import alertComponent from './alert.vue'

let $vm

const alertPlugin = {
	install (vue, pluginOptions = {}) {
		const Alert = vue.extend(alertComponent)

		if (!$vm) {
			$vm = new Alert({
				el: document.createElement('div')
			})
			document.body.appendChild($vm.$el)
		}

		const alert = {
			show (options) {
				if (typeof options === 'string') {
					Object.assign($vm, pluginOptions, {content: options})
				} else if (typeof options === 'object') {
					Object.assign($vm, pluginOptions, options)
				}
				$vm.show = true
				$vm.$on('CloseEvent', () => {
					$vm.show = false
				})
				$vm.promise = new Promise((resolve, reject) => {
					$vm.$on('OkEvent', () => {
						$vm.show = false
						resolve()
					})
				})
				return $vm.promise
			}
		}
		vue.prototype.$alert = alert.show
	}
}

export default alertPlugin



// WEBPACK FOOTER //
// ./src/components/common/alert/index.js